import React from 'react'

export default ({ ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 273.42 72.21' {...props}>
    <defs>
      <style></style>
    </defs>
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          fill='#fff'
          d='M0,70l1.44-1.71A6.3,6.3,0,0,0,5.75,70c1.48,0,2.42-.68,2.42-1.71v0c0-1-.55-1.5-3.08-2.09C2.18,65.5.55,64.64.55,62.13v0c0-2.34,2-4,4.66-4a7.55,7.55,0,0,1,5,1.71L8.87,61.66a6.17,6.17,0,0,0-3.7-1.41c-1.41,0-2.23.73-2.23,1.62v0c0,1.05.63,1.52,3.24,2.15,2.89.7,4.39,1.73,4.39,4v0c0,2.56-2,4.08-4.88,4.08A8.38,8.38,0,0,1,0,70Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M17.36,58.32H27.48v2.15H19.76V64h6.85v2.14H19.76v3.67h7.82V72H17.36Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M39.42,58.23h2.22l6,13.74H45.11l-1.38-3.29H37.27L35.87,72H33.41Zm3.43,8.32-2.36-5.46-2.34,5.46Z'
        />
        <path className='cls-1' fill='#fff' d='M53.81,58.32H64v2.19H56.21v3.72h6.88v2.19H56.21V72h-2.4Z' />
        <path
          className='cls-1'
          fill='#fff'
          d='M69.53,65.19v0a7.14,7.14,0,0,1,14.27,0v0a7.14,7.14,0,0,1-14.27,0Zm11.76,0v0a4.68,4.68,0,0,0-4.64-4.86A4.62,4.62,0,0,0,72,65.11v0A4.68,4.68,0,0,0,76.69,70,4.61,4.61,0,0,0,81.29,65.19Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M90,65.19v0a7.14,7.14,0,0,1,14.28,0v0a7.14,7.14,0,0,1-14.28,0Zm11.76,0v0a4.68,4.68,0,0,0-4.64-4.86,4.61,4.61,0,0,0-4.6,4.82v0A4.67,4.67,0,0,0,97.11,70,4.61,4.61,0,0,0,101.71,65.19Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M111.11,58.32h5.09c4.29,0,7.25,3,7.25,6.79v0c0,3.84-3,6.82-7.25,6.82h-5.09Zm5.09,11.47a4.45,4.45,0,0,0,4.74-4.6v0a4.48,4.48,0,0,0-4.74-4.64h-2.69v9.28Z'
        />
      </g>
      <g id='text_and_wave' data-name='text and wave'>
        <rect className='cls-1' fill='#fff' x='0.86' y='0.45' width='4.65' height='26.49' />
        <path
          className='cls-1'
          fill='#fff'
          d='M32.36,23.12c-5.07,0-8.74-4.24-8.74-9.46s3.67-9.39,8.74-9.39a10.54,10.54,0,0,1,7.42,3.3l3-3.45A13.83,13.83,0,0,0,32.4,0,13.41,13.41,0,0,0,18.74,13.73,13.33,13.33,0,0,0,32.21,27.39,13.67,13.67,0,0,0,43,22.7l-3-3c-2.27,2.12-4.35,3.45-7.61,3.45'
        />
        <polygon
          className='cls-1'
          fill='#fff'
          points='59.81 15.66 73.09 15.66 73.09 11.5 59.81 11.5 59.81 4.62 74.8 4.62 74.8 0.45 55.16 0.45 55.16 26.94 74.99 26.94 74.99 22.78 59.81 22.78 59.81 15.66'
        />
        <polygon
          className='cls-1'
          fill='#fff'
          points='92.49 0.45 87.83 0.45 87.83 26.94 102.2 26.94 103.95 22.7 92.49 22.7 92.49 0.45'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M124,16.42,128.5,5.83l4.58,10.59ZM126.42.26,114.77,26.94h4.77l2.72-6.4h12.52l2.69,6.4h4.92L130.74.26Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M265.18,19.67c-2.27,2.12-4.35,3.45-7.6,3.45-5.07,0-8.74-4.24-8.74-9.46s3.67-9.38,8.74-9.38A10.52,10.52,0,0,1,265,7.57l3-3.45A13.79,13.79,0,0,0,257.61,0,13.41,13.41,0,0,0,244,13.73a13.33,13.33,0,0,0,13.47,13.66,13.65,13.65,0,0,0,10.74-4.69Z'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M51.46,36.84s18.89,3.89,44.67,2.65S166.23,25.9,197.67,25.9c42.55,0,75.75,15.54,75.75,15.54s-39.64-11-75.67-11-65.44,11.2-101.27,11.2c-27.72,0-45-4.81-45-4.81'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M194.58,21.86V4.69h5.22c5.56,0,9.2,3.82,9.2,9a8.49,8.49,0,0,1-5.17,8.19c2.34.09,4.64.21,6.9.38a13,13,0,0,0,3.15-8.64c0-7.49-5.75-13.21-14.08-13.21h-9.87V22c1.57-.08,3.12-.15,4.65-.18'
        />
        <path
          className='cls-1'
          fill='#fff'
          d='M157.8,25.88V8.1L170.14,24c2.07-.28,4.13-.55,6.17-.79V.45h-4.58V18.77L157.54.45h-4.31V26.64l4.57-.76'
        />
        <path className='cls-1' fill='#fff' d='M231.24,24.87V.45h-4.65V24.1c1.59.24,3.14.5,4.65.77' />
      </g>
    </g>
  </svg>
)
